import * as React from 'react';

const BedChairBoxSmall = () => (
  <svg
    width={56}
    height={49}
    viewBox="0 0 56 49"
    strokeWidth={1}
    fillRule="evenodd"
    stroke="#1C1F34"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path stroke="none" fill="#8EAFFF" d="M7.314,25.434 L33.438,25.434 L7.314,25.434 Z" />
    <path stroke="none" fill="#8EAFFF" d="M7.314,25.434 L33.438,25.434 L7.314,25.434 Z" />
    <path strokeWidth={2} d="M4.5,47.25 L52.5,47.25" />
    <path
      stroke="none"
      fill="#E7EBF6"
      d="M8.49,1.75 L39.994,1.75 C42.377,1.75 44.309,3.682 44.309,6.066 L44.309,42.697 C44.309,45.08 42.377,47.012 39.994,47.012 L8.49,47.012 C6.107,47.012 4.175,45.08 4.175,42.697 L4.175,6.066 C4.175,3.682 6.107,1.75 8.49,1.75 Z"
    />
    <path
      stroke="none"
      fill="#FFFFFF"
      d="M42.703,6.345 C42.703,4.694 41.365,3.356 39.715,3.356 L8.769,3.356 C7.119,3.356 5.781,4.694 5.781,6.345 L5.781,42.417 C5.781,44.068 7.119,45.406 8.769,45.406 L39.715,45.406 C41.365,45.406 42.703,44.068 42.703,42.417 L42.703,6.345 Z"
    />
    <polygon
      stroke="none"
      fill="#677BC5"
      points="1.25 11.852 4.175 11.852 4.175 7.532 1.25 7.532"
    />
    <polygon points="1.25 11.852 4.175 11.852 4.175 7.532 1.25 7.532" />
    <path stroke="none" fill="#FFFFFF" d="M12.71,11.3 L12.035,10.625" />
    <path d="M12.71,11.3 L12.035,10.625" />
    <path stroke="none" fill="#FFFFFF" d="M12.71,11.439 L12.035,12.114" />
    <path d="M12.71,11.439 L12.035,12.114" />
    <path stroke="none" fill="#FFFFFF" d="M12.849,11.439 L13.524,12.114" />
    <path d="M12.849,11.439 L13.524,12.114" />
    <path stroke="none" fill="#FFFFFF" d="M12.849,11.3 L13.524,10.625" />
    <path d="M12.849,11.3 L13.524,10.625" />
    <path stroke="none" fill="#FFFFFF" d="M24.173,11.3 L23.498,10.625" />
    <path d="M24.173,11.3 L23.498,10.625" />
    <path stroke="none" fill="#FFFFFF" d="M24.173,11.439 L23.498,12.114" />
    <path d="M24.173,11.439 L23.498,12.114" />
    <path stroke="none" fill="#FFFFFF" d="M24.312,11.439 L24.987,12.114" />
    <path d="M24.312,11.439 L24.987,12.114" />
    <path stroke="none" fill="#FFFFFF" d="M24.312,11.3 L24.987,10.625" />
    <path d="M24.312,11.3 L24.987,10.625" />
    <path stroke="none" fill="#FFFFFF" d="M35.636,11.3 L34.961,10.625" />
    <path d="M35.636,11.3 L34.961,10.625" />
    <path stroke="none" fill="#FFFFFF" d="M35.636,11.439 L34.961,12.114" />
    <path d="M35.636,11.439 L34.961,12.114" />
    <path stroke="none" fill="#FFFFFF" d="M35.775,11.439 L36.45,12.114" />
    <path d="M35.775,11.439 L36.45,12.114" />
    <path stroke="none" fill="#FFFFFF" d="M35.775,11.3 L36.45,10.625" />
    <path d="M35.775,11.3 L36.45,10.625" />
    <path stroke="none" fill="#FFFFFF" d="M12.71,24.562 L12.035,23.887" />
    <path d="M12.71,24.562 L12.035,23.887" />
    <path stroke="none" fill="#FFFFFF" d="M12.71,24.7 L12.035,25.375" />
    <path d="M12.71,24.7 L12.035,25.375" />
    <path stroke="none" fill="#FFFFFF" d="M12.849,24.7 L13.524,25.375" />
    <path d="M12.849,24.7 L13.524,25.375" />
    <path stroke="none" fill="#FFFFFF" d="M12.849,24.562 L13.524,23.887" />
    <path d="M12.849,24.562 L13.524,23.887" />
    <path stroke="none" fill="#FFFFFF" d="M24.173,24.562 L23.498,23.887" />
    <path strokeWidth={1.5} d="M24.173,24.562 L23.498,23.887" />
    <path stroke="none" fill="#FFFFFF" d="M24.173,24.7 L23.498,25.375" />
    <path strokeWidth={1.5} d="M24.173,24.7 L23.498,25.375" />
    <path stroke="none" fill="#FFFFFF" d="M24.312,24.7 L24.987,25.375" />
    <path strokeWidth={1.5} d="M24.312,24.7 L24.987,25.375" />
    <path stroke="none" fill="#FFFFFF" d="M24.312,24.562 L24.987,23.887" />
    <path strokeWidth={1.5} d="M24.312,24.562 L24.987,23.887" />
    <path stroke="none" fill="#FFFFFF" d="M35.636,24.562 L34.961,23.887" />
    <path strokeWidth={1.5} d="M35.636,24.562 L34.961,23.887" />
    <path stroke="none" fill="#FFFFFF" d="M35.636,24.7 L34.961,25.375" />
    <path strokeWidth={1.5} d="M35.636,24.7 L34.961,25.375" />
    <path stroke="none" fill="#FFFFFF" d="M35.775,24.7 L36.45,25.375" />
    <path strokeWidth={1.5} d="M35.775,24.7 L36.45,25.375" />
    <path stroke="none" fill="#FFFFFF" d="M35.775,24.562 L36.45,23.887" />
    <path strokeWidth={1.5} d="M35.775,24.562 L36.45,23.887" />
    <path stroke="none" fill="#FFFFFF" d="M12.71,37.823 L12.035,37.148" />
    <path strokeWidth={1.5} d="M12.71,37.823 L12.035,37.148" />
    <path stroke="none" fill="#FFFFFF" d="M12.71,37.962 L12.035,38.637" />
    <path strokeWidth={1.5} d="M12.71,37.962 L12.035,38.637" />
    <path stroke="none" fill="#FFFFFF" d="M12.849,37.962 L13.524,38.637" />
    <path strokeWidth={1.5} d="M12.849,37.962 L13.524,38.637" />
    <path stroke="none" fill="#FFFFFF" d="M12.849,37.823 L13.524,37.148" />
    <path strokeWidth={1.5} d="M12.849,37.823 L13.524,37.148" />
    <path
      strokeWidth={2}
      d="M8.49,1.75 L39.994,1.75 C42.377,1.75 44.309,3.682 44.309,6.066 L44.309,42.697 C44.309,45.08 42.377,47.012 39.994,47.012 L8.49,47.012 C6.107,47.012 4.175,45.08 4.175,42.697 L4.175,6.066 C4.175,3.682 6.107,1.75 8.49,1.75 Z"
    />
    <path
      stroke="none"
      fill="#677BC5"
      d="M51.444,24.314 C50.677,24.314 49.995,24.527 49.394,24.916 C49.469,24.547 49.511,24.171 49.511,23.788 C49.511,19.141 43.789,15.373 36.73,15.373 C29.671,15.373 23.948,19.141 23.948,23.788 C23.948,24.17 23.989,24.546 24.064,24.914 C23.462,24.527 22.782,24.314 22.015,24.314 C18.006,24.314 18.66,28.406 18.66,28.406 C18.881,30.354 21.131,34.326 21.335,43.315 C21.348,43.834 21.77,44.249 22.289,44.249 L36.73,44.249 L51.17,44.249 C51.69,44.249 52.112,43.834 52.124,43.315 C52.329,34.326 54.578,30.354 54.8,28.406 C54.8,28.406 55.454,24.314 51.444,24.314"
    />
    <path
      strokeWidth={2}
      d="M36.73,44.349 L22.289,44.349 C21.77,44.249 21.348,43.834 21.336,43.315 C21.13,34.326 18.881,30.354 18.66,28.406 C18.66,28.406 18.005,24.314 22.015,24.314 C26.026,24.314 27.716,30.103 27.716,36.651 L27.716,39.155 L36.73,39.155"
    />
    <path strokeWidth={1.5} d="M27.716,39.155 L27.716,44.249" />
    <path strokeWidth={2} d="M36.73,15.374 C36.73,15.374 23.948,15.02 23.948,24.494" />
    <path
      strokeWidth={2}
      d="M36.73,44.349 L51.17,44.349 C51.69,44.249 52.112,43.834 52.124,43.315 C52.329,34.326 54.578,30.354 54.799,28.406 C54.799,28.406 55.454,24.314 51.444,24.314 C47.434,24.314 45.744,30.103 45.744,36.651 L45.744,39.155 L36.73,39.155"
    />
    <path d="M45.744,33.139 C45.367,32.316 43.816,32.354 43.816,32.354 L29.644,32.354 C29.644,32.354 28.092,32.316 27.716,33.139" />
    <path strokeWidth={1.5} d="M45.744,39.155 L45.744,44.249" />
    <path strokeWidth={2} d="M36.73,15.374 C36.73,15.374 49.512,15.02 49.512,24.494" />
    <polygon
      stroke="none"
      fill="#DEDEDE"
      points="24.145 47.188 26.484 47.188 26.984 44.349 23.645 44.349"
    />
    <polygon
      stroke="none"
      fill="#DEDEDE"
      points="47 47.188 49.339 47.188 49.839 44.349 46.5 44.349"
    />
    <polygon strokeWidth={2} points="24.145 47.188 26.484 47.188 26.984 44.349 23.645 44.349" />
    <polygon strokeWidth={2} points="47 47.188 49.339 47.188 49.839 44.349 46.5 44.349" />
    <polygon stroke="none" fill="#E7EBF6" points="10.5 46.5 34.5 46.5 34.5 30.5 10.5 30.5" />
    <path
      stroke="none"
      fill="#3A427C"
      d="M33.875,37 L11.125,37 C10.78,37 10.5,36.664 10.5,36.25 C10.5,35.836 10.78,35.5 11.125,35.5 L33.875,35.5 C34.22,35.5 34.5,35.836 34.5,36.25 C34.5,36.664 34.22,37 33.875,37"
      opacity={0.2}
    />
    <polygon strokeWidth={2} points="11.25 47.25 33.75 47.25 33.75 35.25 11.25 35.25" />
    <polygon strokeWidth={2} points="10.25 35.25 35.25 35.25 35.25 31.25 10.25 31.25" />
  </svg>
);

export default BedChairBoxSmall;



// WEBPACK FOOTER //
// ./src/assets/images/icons/bed-chair-box-small.js